import _           from 'underscore';
import * as Stores from './_stores';
import { asType }  from './_apolloUtil';

export const rootStoreKey = 'Store';

const storeRoots = {};

_.mapObject( Stores, store => {
	storeRoots[ store.storeKey ] = store.state;
} );

export const _state = asType( rootStoreKey, {
	...storeRoots
} );